// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--1b5b4";
export var copy = "footer-module--copy--cb6f1";
export var copyLinks = "footer-module--copyLinks--6fcae";
export var copyText = "footer-module--copyText--47fcf";
export var divider = "footer-module--divider--31323";
export var hours = "footer-module--hours--7e083";
export var iconEmail = "footer-module--iconEmail--a0b82";
export var iconPhone = "footer-module--iconPhone--1eb16";
export var infoFooterWrapper = "footer-module--infoFooterWrapper--c6615";
export var infoList = "footer-module--infoList--cd9cb";
export var infoListItem = "footer-module--infoListItem--b8d34";
export var linksFooterGrid = "footer-module--linksFooterGrid--dc883";
export var linksFooterList = "footer-module--linksFooterList--28550";
export var linksFooterListItem = "footer-module--linksFooterListItem--882a3";
export var linksFooterWrapper = "footer-module--linksFooterWrapper--157e1";
export var logo = "footer-module--logo--12e5e";
export var logoContainer = "footer-module--logoContainer--6b7be";
export var strapline = "footer-module--strapline--0cb83";